import React from 'react';

import { WindowWidthContext } from '@minecraft.utils';

import Base from './Base';
import CoverPhoto from './CoverPhoto';
import Icon from './Icon';
import Measurements from './Measurements';
import StageName from './StageName';
import Unions from './Unions';
import WorkingLocations from './WorkingLocations';
import { Banner } from './Banner';
import { Section } from './Section';

export const LoadingBaseballCard = () => {
  const isMobile = WindowWidthContext.useIsMobile();

  return (
    <Base backgroundColor="none" borderColor="none" loading>
      <Section flexDirection={isMobile ? 'row' : 'column'} alignItems="initial" grow={1} size="large" wrap="nowrap">
        {!isMobile && <Banner />}
        <CoverPhoto loading />
        <Section alignItems="initial" size="small" grow={1}>
          <StageName loading />
          <Measurements loading />
          <Unions loading />
          <WorkingLocations loading />
        </Section>
      </Section>
      <Section alignItems="initial" flexDirection="row" gap="2" grow={0} size="small">
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
        <Icon loading size="1rem" />
      </Section>
    </Base>
  );
};

export const LoadingBaseballCards = (props: { count: number }) => (
  <>
    {Array.from(Array(props.count).keys()).map((value) => (
      <LoadingBaseballCard key={`loading-baseball-card-${value}`} />
    ))}
  </>
);
